"use strict";
/**
 * Common response types for API network layer
 * These generic interfaces reduce duplication and provide consistent typing
 * across all model classes in the application.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPaginatedResponse = isPaginatedResponse;
exports.hasMessage = hasMessage;
/**
 * Type guard to check if a response is paginated
 */
function isPaginatedResponse(response) {
    return (response &&
        typeof response.current_page === "number" &&
        Array.isArray(response.data) &&
        typeof response.total === "number");
}
/**
 * Type guard to check if a response has a message
 */
function hasMessage(response) {
    return response && typeof response.message === "string";
}
